export default __webpack_public_path__ + "static/media/cactus.6d89d6c0.png";